<template>
  <v-col cols="12" class="pa-0">
    <v-row class="ma-0">
      <v-col cols="12" class="pb-1">
        <label>Ingresa el correo para poder enviar el pago</label>
      </v-col>
    </v-row>

    <v-row class="ma-0" align="center">
      <v-col cols="12" md="8">
        <v-tooltip bottom color="blue" max-width="300">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="email"
              @input="$emit('update:email', $event)"
              label="Correo del alumno"
              filled
              hide-details
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <span>Email donde se enviará el comprobante de pago</span>
        </v-tooltip>
      </v-col>

      <v-col cols="12" md="4" class="d-flex align-center">
        <v-btn
          color="primary"
          small
          tile
          block
          :loading="cargando"
          :disabled="!idAlumno || cargando"
          @click="$emit('actualizar-correo')"
        >
          <v-icon left small>mdi-email-sync</v-icon>
          Actualizar correo
        </v-btn>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: 'ReciboContactoCampos',
  props: {
    email: {
      type: String,
      default: '',
    },
    idAlumno: {
      type: [ Number, String ],
      default: null,
    },
    cargando: {
      type: Boolean,
      default: false,
    },
    // WhatsApp recibo: deshabilitado temporalmente
    // celular: {
    //   type: String,
    //   default: '',
    // },
  },
}
</script>
